import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import SFGTransportationTable from "./SFGTransportationTable";
import btnDownloadIcon from "../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
  enableEditFilter,
  loadCascadeOptions,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  BULK_EDIT_MANUFACTURING_MASTER_TABLE_API,
  DISPLAY_MANUFACTURING_MASTER_1_TABLE_API,
  DOWNLOAD_MANUFACTURING_MASTER_1_TABLE_API,
  LONG_BULK_EDITCFG_TRANSPORTATION_API,
  LONG_CFG_TRANSPORTATION_DOWNLOAD_API,
  LONG_CFG_TRANSPORTATION_GET_API,
  LONG_FACILITY_MASTER_GET_API,
  VIEW_MANUFACTURING_MASTER_1_TABLE_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function SFGTransportation(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectProcessingCode, setSelectProcessingCode] = useState<any>("");
  const [selectPackagingDescription, setSelectPackagingDescription] =
    useState<any>("");
  const [selectProcessingDescription, setSelectProcessingDescription] =
    useState<any>("");
  const [selectPackagingCode, setSelectPackagingCode] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [processingCodeOptions, setProcessingCodeOptions] = React.useState([]);
  const [packagingDescriptionOptions, setPackagingDescriptionOptions] =
    useState<any>([]);
  const [SFGOptions, setSFGOptions] = useState<any>([]);
  const [selectSFG, setSelectSFG] = useState<any>("");
  const [SFGDescriptionOptions, setSFGDescriptionOptions] = useState<any>([]);
  const [selectSFGDescription, setSelectSFGDescription] = useState<any>("");
  const [timePeriodOptions, setTimePeriodOptions] = useState<any>([]);
  const [selectTimePeriod, setSelectTimePeriod] = useState<any>("");
  const [processingDescriptionOptions, setprocessingDescriptionOptions] =
    useState<any>([]);
  const [packagingPlantOptions, setPackagingPlantOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "processing_Plant_Code", value: "" },
    { key: "processing_Plant_Description", value: "" },
    { key: "packaging_Plant_Code", value: "" },
    { key: "packaging_Plant_Description", value: "" },
    { key: "sfG_Code", value: "" },
    { key: "sfG_Description", value: "" },
    { key: "time_Period", value: "" },
  ]);

  const sortedProcessingCodeNames = processingCodeOptions?.sort(
    (a: any, b: any) =>
      a?.processing_Plant_Code.localeCompare(b?.processing_Plant_Code),
  );

  const sortedProcessingPlantNames = packagingPlantOptions?.sort(
    (a: any, b: any) =>
      a?.packaging_Plant_Code.localeCompare(b?.packaging_Plant_Code),
  );
  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData,
  );

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage,
  );

  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);
  const [tableName, setTableName] = useState<any>(
    "tblScenario_SFGTransportation_LT",
  );

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  useEffect(() => {
    if (folderModuleName === "module2") {
      setTableName("tblScenario_SFGTransportation_LT_Module2");
      getfiltersApi("tblScenario_SFGTransportation_LT_Module2");
    } else if (folderModuleName === "module3") {
      setTableName("tblScenario_SFGTransportation_LT_Module3");
      getfiltersApi("tblScenario_SFGTransportation_LT_Module3");
    } else if (folderModuleName === "module4") {
      setTableName("tblScenario_SFGTransportation_LT_Module4");
      getfiltersApi("tblScenario_SFGTransportation_LT_Module4");
    } else if (folderModuleName === "module5") {
      setTableName("tblScenario_SFGTransportation_LT_Module5");
      getfiltersApi("tblScenario_SFGTransportation_LT_Module5");
    } else if (folderModuleName === "module6") {
      setTableName("tblScenario_SFGTransportation_LT_Module6");
      getfiltersApi("tblScenario_SFGTransportation_LT_Module6");
    } else {
      setTableName("tblScenario_SFGTransportation_LT");
      getfiltersApi("tblScenario_SFGTransportation_LT");
    }
  }, [folderModuleName, selectedScenarioId]);

  var ProcessingCode = 0;
  var ProcessingDescription = 0;
  var PackagingCode = 0;
  var PackagingDescription = 0;
  var SFGCode = 0;
  var SFGDescription = 0;
  var time = 0;

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: selectedScenarioId,
        processing_Plant_Code: "",
        processing_Plant_Description: "",
        packaging_Plant_Code: "",
        packaging_Plant_Description: "",
        sfG_Code: "",
        sfG_Description: "",
        time_Period: "",
        min_Capacity: 0,
        max_Capacity: 0,
        distance: 0,
        cpt: 182.01,
        lead_Time: 0,
        cO2: 0,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };
  const handleChangeSelectProcessingCode = (event: any) => {
    setSelectPackagingCode("");
    setSelectPackagingDescription("");
    setSelectSFG("");
    setSelectSFGDescription("");
    setSelectProcessingDescription("");
    setSelectTimePeriod("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    filterRequest[6].value = "";
    const {
      target: { value },
    } = event;
    setSelectProcessingCode(value);
    filterRequest[0].value = value;
    callTableGridApi();
    ProcessingCode = 1;
    ProcessingDescription = 0;
    PackagingCode = 0;
    PackagingDescription = 0;
    SFGCode = 0;
    SFGDescription = 0;
    time = 0;
  };

  const handleChangeSelectProcessingDescription = (event: any) => {
    const {
      target: { value },
    } = event;
    filterRequest[1].value = value;
    setSelectProcessingDescription(value);
    setSelectPackagingCode("");
    setSelectPackagingDescription("");
    setSelectSFG("");
    setSelectSFGDescription("");
    setSelectTimePeriod("");
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    filterRequest[6].value = "";
    callTableGridApi();
    ProcessingCode = 1;
    ProcessingDescription = 1;
    PackagingCode = 0;
    PackagingDescription = 0;
    SFGCode = 0;
    SFGDescription = 0;
    time = 0;
  };

  const handleChangeSelectProcessingPlant = (event: any) => {
    const {
      target: { value },
    } = event;
    setSelectPackagingCode(value);
    filterRequest[2].value = value;
    setSelectSFG("");
    setSelectSFGDescription("");
    setSelectPackagingDescription("");
    setSelectTimePeriod("");
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    filterRequest[6].value = "";
    callTableGridApi();
    ProcessingCode = 1;
    ProcessingDescription = 1;
    PackagingCode = 1;
    PackagingDescription = 0;
    SFGCode = 0;
    SFGDescription = 0;
    time = 0;
  };

  const handleChangeSelectPackagingDescription = (event: any) => {
    const {
      target: { value },
    } = event;
    filterRequest[3].value = value;
    setSelectPackagingDescription(value);
    setSelectSFG("");
    setSelectSFGDescription("");
    setSelectTimePeriod("");
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    filterRequest[6].value = "";
    callTableGridApi();
    ProcessingCode = 1;
    ProcessingDescription = 1;
    PackagingCode = 1;
    PackagingDescription = 1;
    SFGCode = 0;
    SFGDescription = 0;
    time = 0;
  };

  const handleChangeSelectSFG = (event: any) => {
    const {
      target: { value },
    } = event;
    filterRequest[4].value = value;
    setSelectSFG(value);
    setSelectSFGDescription("");
    setSelectTimePeriod("");
    filterRequest[5].value = "";
    filterRequest[6].value = "";
    callTableGridApi();
    ProcessingCode = 1;
    ProcessingDescription = 1;
    PackagingCode = 1;
    PackagingDescription = 1;
    SFGCode = 1;
    SFGDescription = 0;
    time = 0;
  };

  const handleChangeSelectSFGDescription = (event: any) => {
    const {
      target: { value },
    } = event;
    filterRequest[5].value = value;
    setSelectSFGDescription(value);
    setSelectTimePeriod("");
    filterRequest[6].value = "";
    callTableGridApi();
    ProcessingCode = 1;
    ProcessingDescription = 1;
    PackagingCode = 1;
    PackagingDescription = 1;
    SFGCode = 1;
    SFGDescription = 1;
    time = 0;
  };

  const handleChangeSelectTimePeriod = (event: any) => {
    const {
      target: { value },
    } = event;
    filterRequest[6].value = value;
    setSelectTimePeriod(value);
    callTableGridApi();
    ProcessingCode = 1;
    ProcessingDescription = 1;
    PackagingCode = 1;
    PackagingDescription = 1;
    SFGCode = 1;
    SFGDescription = 1;
    time = 1;
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    const requestParam = {
      usecaseId: 0,
      category_id: 0,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    const urls = API_BASE_URL + LONG_CFG_TRANSPORTATION_DOWNLOAD_API;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  useEffect(() => {
    callTableGridApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
    selectedTimePeriodData,
  ]);
  const callTableGridApi = (resetfilter?: any) => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    console.log(selectedScenarioId, "scenario2");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,

      table: tableName,
      pagesize: 100,
      filter: filterList,
      time_period: timePeriodValues,
    };

    console.log(requestParam, "params");

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_CFG_TRANSPORTATION_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          console.log(response.data, requestParam, "basepack2dddd");
          setRows(response.data);
          if (ProcessingDescription === 0) {
            setprocessingDescriptionOptions(
              loadProcessingDescriptionOptions(response.data),
            );
          }
          if (ProcessingCode === 0)
            setProcessingCodeOptions(loadProcessingCodeOptions(response.data));
          if (PackagingCode === 0)
            setPackagingPlantOptions(loadPackagingPlantOptions(response.data));
          if (PackagingDescription === 0) {
            setPackagingDescriptionOptions(
              loadPackagingDescriptionOptions(response.data),
            );
          }
          if (SFGCode === 0) {
            setSFGOptions(loadSFGOptions(response.data));
          }
          if (SFGDescription === 0) {
            setSFGDescriptionOptions(loadSFGOptionsDescription(response.data));
          }
          if (time === 0) {
            setTimePeriodOptions(loadTimePeriodOptions(response.data));
          }
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadProcessingCodeOptions = (data: any) => {
    const processingCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = processingCodeOptions.find((obj: any) => {
        return obj.processing_Plant_Code === item.processing_Plant_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        processingCodeOptions.push({
          id: item.id,
          processing_Plant_Code: item.processing_Plant_Code,
        });
      }
    });
    return processingCodeOptions;
    //setProcessingCodeOptions(factoryOptions);
  };

  const loadProcessingDescriptionOptions = (data: any) => {
    const processingDescriptionOptions: any = [];
    data.map((item: any) => {
      const filteredItem = processingDescriptionOptions.find((obj: any) => {
        return (
          obj.processing_Plant_Description === item.processing_Plant_Description
        );
      });
      if (filteredItem === undefined || filteredItem == null) {
        processingDescriptionOptions.push({
          id: item.id,
          processing_Plant_Description: item.processing_Plant_Description,
        });
      }
    });
    return processingDescriptionOptions;
    //setProcessingCodeOptions(factoryOptions);
  };

  const loadPackagingDescriptionOptions = (data: any) => {
    console.log(data, "basepack");
    const packagingDescriptionOptions: any = [];
    data.map((item: any) => {
      const filteredItem = packagingDescriptionOptions.find((obj: any) => {
        return (
          obj.packaging_Plant_Description === item.packaging_Plant_Description
        );
      });
      if (filteredItem === undefined || filteredItem == null) {
        packagingDescriptionOptions.push({
          id: item.id,
          packaging_Plant_Description: item.packaging_Plant_Description,
        });
      }
    });
    return packagingDescriptionOptions;
  };

  const loadPackagingPlantOptions = (data: any) => {
    const packagingPlantOptions: any = [];
    data.map((item: any) => {
      const filteredItem = packagingPlantOptions.find((obj: any) => {
        return obj.packaging_Plant_Code === item.packaging_Plant_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        packagingPlantOptions.push({
          id: item.id,
          packaging_Plant_Code: item.packaging_Plant_Code,
        });
      }
    });
    return packagingPlantOptions;
  };

  const loadSFGOptions = (data: any) => {
    const SFGOptions: any = [];
    data.map((item: any) => {
      const filteredItem = SFGOptions.find((obj: any) => {
        return obj.sfG_Code === item.sfG_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        SFGOptions.push({ id: item.id, sfG_Code: item.sfG_Code });
      }
    });
    return SFGOptions;
  };

  const loadSFGOptionsDescription = (data: any) => {
    const SFGDescriptionOptions: any = [];
    data.map((item: any) => {
      const filteredItem = SFGDescriptionOptions.find((obj: any) => {
        return obj.sfG_Description === item.sfG_Description;
      });
      if (filteredItem === undefined || filteredItem == null) {
        SFGDescriptionOptions.push({
          id: item.id,
          sfG_Description: item.sfG_Description,
        });
      }
    });
    return SFGDescriptionOptions;
  };

  const loadTimePeriodOptions = (data: any) => {
    const timePeriodOptions: any = [];
    data.map((item: any) => {
      const filteredItem = timePeriodOptions.find((obj: any) => {
        return obj.time_Period === item.time_Period;
      });
      if (filteredItem === undefined || filteredItem == null) {
        timePeriodOptions.push({ id: item.id, time_Period: item.time_Period });
      }
    });
    return timePeriodOptions;
  };

  const getfiltersApi = (tableeName?: string) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    //const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    // const requestParam = { "usecaseId": selectedUsecaseId, "category_id": selectedCategoryId,"folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": selectedScenarioId > 0 ? "tblManufacturingMaster_HC_Rerun" : "tblManufacturingMaster", "time_period": "string","ispagination": 1, "page": 1, "pagesize": 100, "filter": filterList };
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: tableeName ?? tableName,
      filter: filterList,
      time_period: selectTimePeriod,
    };

    dispatch(ViewProductTableStart());
    const urls = API_BASE_URL + LONG_CFG_TRANSPORTATION_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          console.log(response.data, requestParam, "basepack2dddd");
          setRows(response.data);
          console.log(response.data, "response");
          setProcessingCodeOptions(loadProcessingCodeOptions(response.data));
          setPackagingDescriptionOptions(
            loadPackagingDescriptionOptions(response.data),
          );
          setSFGOptions(loadSFGOptions(response.data));
          setSFGDescriptionOptions(loadSFGOptionsDescription(response.data));
          setTimePeriodOptions(loadTimePeriodOptions(response.data));
          setprocessingDescriptionOptions(
            loadProcessingDescriptionOptions(response.data),
          );
          setPackagingPlantOptions(loadPackagingPlantOptions(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  // useEffect(() => {
  //   getfiltersApi()
  // }, [ tableName,selectedFolderId, selectedScenarioId])

  const handleRestoreClicked = (e: any) => {
    setSelectProcessingCode("");
    setSelectPackagingDescription("");
    setSelectSFG("");
    setSelectSFGDescription("");
    setSelectProcessingDescription("");
    setSelectPackagingCode("");
    setSelectTimePeriod("");
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    filterRequest[6].value = "";
    ProcessingCode = 0;
    ProcessingDescription = 0;
    PackagingCode = 0;
    PackagingDescription = 0;
    SFGCode = 0;
    SFGDescription = 0;
    time = 0;
    callTableGridApi([]);
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const handleFetchEditData = (val: any) => {
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "processing_Plant_Code",
      "processing_Plant_Description",
      "packaging_Plant_Code",
      "packaging_Plant_Description",
      "sfG_Code",
      "sfG_Description",
      "time_Period",
      "min_Capacity",
      "max_Capacity",
      "distance",
      "cpt",
      "lead_Time",
      "cO2",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0,
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    const urls = API_BASE_URL + LONG_BULK_EDITCFG_TRANSPORTATION_API;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      moduleKey: Number(folderModuleName.slice(-1)),
      data: transformedRows,
    };

    putRequest(urls, payload, header, {})
      .then((response) => {
        if (response.status == 200) {
          callTableGridApi();
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        handleClose();
      });
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited SFG Transportation table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="SFG Transportation"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>SFG Transportation</h3>
          </div>
          <div className="filters">
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Facility Code</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectProcessingCode}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectProcessingCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Processing Plant Code</em>
                  </MenuItem>
                  {sortedProcessingCodeNames?.map((d: any) => {
                    // return (<MenuItem key={d} value={d.factory}>{d.factory}</MenuItem>)
                    return (
                      <MenuItem key={d} value={d.processing_Plant_Code}>
                        {d.processing_Plant_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {/* <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-2"
                  value={selectProcessingDescription}
                  placeholder="Select Cascade"
                  onChange={handleChangeSelectProcessingDescription}
                  className="select-short-term"
                  inputProps={{ 'aria-label': 'Without label' }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Processing Plant Description</em>
                  </MenuItem>
                  {processingDescriptionOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.processing_Plant_Description}>
                        {d.processing_Plant_Description}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </div> */}
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Facility Description</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectPackagingCode}
                  placeholder="Select Line"
                  onChange={handleChangeSelectProcessingPlant}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Packaging Plant Code</em>
                  </MenuItem>
                  {sortedProcessingPlantNames?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.packaging_Plant_Code}>
                        {d.packaging_Plant_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {/* <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-4"
                  value={selectPackagingDescription}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectPackagingDescription}
                  className="select-short-term"
                  inputProps={{ 'aria-label': 'Without label' }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Packaging Plant Description</em>
                  </MenuItem>
                  {packagingDescriptionOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.packaging_Plant_Description}>
                        {d.packaging_Plant_Description}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </div> */}
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Flag</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectSFG}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectSFG}
                  // renderValue={(selectflag: any) => selectflag}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>SFG Code</em>
                  </MenuItem>
                  {SFGOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.sfG_Code}>
                        {d.sfG_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {/* <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                <Select
                  id="simple-select-4"
                  value={selectSFGDescription}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectSFGDescription}
                  className="select-short-term"
                  inputProps={{ 'aria-label': 'Without label' }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>SFG Description</em>
                  </MenuItem>
                  {SFGDescriptionOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.sfG_Description}>
                        {d.sfG_Description}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </div> */}
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown">
                {/* <InputLabel>Flag</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectTimePeriod}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectTimePeriod}
                  // renderValue={(selectflag: any) => selectflag}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Time Period</em>
                  </MenuItem>
                  {timePeriodOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.time_Period}>
                        {d.time_Period}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <SFGTransportationTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default SFGTransportation;
